import { useMutation } from '@tanstack/react-query';
import { useBffClient } from './client';

export type AgentPlatform = 'windows' | 'linux';

export interface AgentDownloadResponse {
  url: string;
  token: string;
  expiresAt: string;
}

/**
 * Requests a short-lived, entitlement-checked agent-download token from the BFF
 * (ADR-008). Returns a ready-to-use URL pointing at the downloads Worker.
 */
export function useRequestAgentDownload() {
  const client = useBffClient();
  return useMutation({
    mutationFn: (platform: AgentPlatform) =>
      client.post<AgentDownloadResponse>('/bff/downloads/agent-token', { platform }),
  });
}
